import { createPinia, setActivePinia } from '@sqt/pinia'

/**
 * 全应用一份 pinia。createStore 和路由都从这里取，另建一份会对不上 inject。
 * 实现在 npm 的 `@sqt/pinia`，这里不再抄一份。
 */
export {
	createPinia,
	createStore,
	defineStore,
	storeToRefs,
	acceptHMRUpdate,
	getActivePinia,
	setActivePinia,
	mapActions,
	mapGetters,
	mapState,
	mapStores,
	mapWritableState,
	setMapStoreSuffix,
} from '@sqt/pinia'
export type * from '@sqt/pinia'

export const pinia = createPinia()
// 路由在 app.use 之前就 useStore。先登记这份，否则没有 active pinia，调用会抛
setActivePinia(pinia)
